import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { NotFoundRoute } from "./NotFound";
import { Location } from "react-router-dom";
import { SentryError } from "@/shared/sentry/sentry";
import { isPresent } from "@/cms/isPresent";

// Adjust your imports and utilities as needed

interface Props {
  children?: React.ReactNode;
  delay?: string | number | null;
  exact?: boolean;
  from?: string;
  push?: boolean;
  strict?: boolean;
  to: string; // Assuming 'to' is always required and a string for simplification
  location?: Location; // Use 'Location' from 'history' if you need to type this deeply
}

interface State {
  isRedirecting?: boolean;
}

interface NavigateFunction<T = unknown> {
  (to: string, options?: { replace?: boolean; state?: T }): void;
}

class RemindmeRedirect extends React.PureComponent<Props & { navigate: NavigateFunction }, State> {
  state: State = {
    isRedirecting: !isPresent(this.props.delay) || isNaN(Number(this.props.delay)) || Number(this.props.delay) <= 0,
  };

  timeout: NodeJS.Timeout | undefined;

  componentDidMount() {
    const { to, location, delay, navigate } = this.props;
    if (to === NotFoundRoute && location && location.pathname !== NotFoundRoute) {
      if (location.key) {
        SentryError(new Error(`Route not found (${location.pathname}), redirect to 404 page`));
      }
      window.location.href = NotFoundRoute;
      return;
    }

    if (isPresent(delay) && !isNaN(Number(delay)) && Number(delay) > 0) {
      this.timeout = setTimeout(() => {
        this.setState({ isRedirecting: true });
        navigate(to, { replace: true });
      }, Number(delay));
    }
  }

  componentWillUnmount() {
    if (this.timeout !== undefined) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    const { children, to } = this.props;
    const { isRedirecting } = this.state;

    if (isRedirecting) {
      // Using Navigate for redirection
      return <Navigate to={to} replace={true} />;
    }

    return children || null;
  }
}

const RedirectWrapper: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  return <RemindmeRedirect {...props} navigate={navigate} />;
};

export { RedirectWrapper as Redirect };
